module.exports = __webpack_public_path__ + "assets/img/how-to-donate-img-3.fa11557f.jpg";